import { FieldConfig } from "@/components/form-builder";

export const forgotPasswordFormFields: FieldConfig[] = [
  {
    name: "email",
    type: "email",
    label: "E-mail",
    required: true,
    placeholder: "Digite seu e-mail",
    colSpan: 2,
  }
]